// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.domain-link[data-v-2fa803c0] {\n  text-decoration: none;\n  margin-right: 4px;\n}\n.snt-salepage-card__img[data-v-2fa803c0] {\n  background-color: #C9C9C9;\n  text-align: end;\n  padding: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
